module.exports = __webpack_public_path__ + "img/phone-fill.0059778b.svg";